<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-input
                            size="small"
                            style="width:300px;"
                            placeholder="请输入用户手机号 / 任务名称"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        

                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.status" clearable placeholder="状态">
                            <el-option key="1" label="进行中" value="1"> </el-option>
                            <el-option key="2" label="待审核" value="2"> </el-option>
                            <el-option key="3" label="已完成" value="3"> </el-option>
                            <el-option key="4" label="已取消" value="4"> </el-option>
                        </el-select>
                        <el-date-picker
                        @change="query"
                        :clearable="false"
                        size="small" 
                        style="width:300px;margin-left:20px"
                        v-model="queryModel.times"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-100"
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column
                            prop="Id"
                            label="Id">
                        </el-table-column>
                       <el-table-column
                            prop="AppName"
                            label="任务名称">
                        </el-table-column>
                        <el-table-column
                            prop="Phone"
                            label="会员账号">
                        </el-table-column>
                        <el-table-column
                            prop="OrderTime"
                            label="接单时间">
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" type="" v-if="scope.row.Status==1">进行中</el-tag>
                                <el-tag size="mini" type="warning" v-else-if="scope.row.Status==2">待审核</el-tag>
                                <el-tag size="mini" type="success" v-else-if="scope.row.Status==3">已完成</el-tag>
                                <el-tag size="mini" type="danger" v-else-if="scope.row.Status==4">已取消</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="是否提交">
                            <template slot-scope="scope">
                                <el-tag effect="dark" style="cursor:pointer" @click="changeSumbit(false,scope.row)" size="mini" type="success" v-if="scope.row.IsSubmit">已提交</el-tag>
                                <el-tag effect="dark" style="cursor:pointer" @click="changeSumbit(true,scope.row)" size="mini" type="danger" v-else>未提交</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="ReviewTime"
                            label="审核时间">
                        </el-table-column>
                        <el-table-column
                            prop="FailReason"
                            label="不通过原因">
                        </el-table-column>
                        <el-table-column
                            label="操作">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.Status==2" size="mini" type="" @click="review(scope.row)" >审核</el-button>
                                 <el-button v-if="scope.row.Status==2||scope.row.Status==1" size="mini" type="danger" @click="canel(scope.row)" >取消</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>

    <el-drawer
    size="50%"
        :modal="true"
        style="z-index:9999"
        title="任务审核"
        :visible.sync="overVisible">
            <el-form  style="padding:20px"    ref="overForm" label-width="170px">
                <el-form-item label="任务名称：" >
                    {{setRow.AppName}}
                </el-form-item>
                <el-form-item label="交单描述：">
                     {{setRow.DeliverDescription}}
                </el-form-item>
                <el-form-item label="交单示例图片：">
                      <img v-for="(v,i)  in setRow.DeliverExampleList" @click="viewImg(setRow.DeliverExampleList)" :key="i" :src="v" :width="100" style="margin-right:10px;cursor:pointer">
                </el-form-item>
                <el-form-item label="交单内容：">
                     {{setRow.SubmitText}}
                </el-form-item>
                <el-form-item label="交单图片：">
                       <img v-for="(v,i)  in setRow.SumbitImgList" @click="viewImg(setRow.SumbitImgList)" :key="i" :src="v" :width="100" style="margin-right:10px;cursor:pointer">
                </el-form-item>
                <el-form-item label="不通过原因：" >
                    <el-input placeholder="请输入不通过原因" v-model="reviewMode.failReason"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align:center">
               
                <el-button :loading="isLoadingPass" type="danger" @click="sumbitReview(1)">不通过</el-button>
                 <el-button :loading="isLoadingPass" type="success" @click="sumbitReview(3)">通过</el-button>
            </div>    
        </el-drawer>
            <el-image-viewer 
                :on-close="close" 
                style="z-index:9999;text-align:left"
                v-if="imageVisible"  
                :url-list="viewImgList" />
        </el-row>
    </div>
</template>
<script>
import { taskOtherGetOrder,taskOtherReview,taskOtherChangeSumbit,taskOtherCanel} from '@/request.js'
import { formatDate } from '@/commonUtil.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: {
      ElImageViewer
  },
    props:{

    },
    data(){
        return {
            imageVisible:false,
            viewImgList:[],
            isLoadingPass:false,
            setRow:{},
            overVisible:false,
            isLoading:false,
            queryModel:{    
                status:"",
                times:[],
                queryTxt:"",
                pIndex:1,
                pSize:20,
            },
            total:0,
            tableData:[],
            reviewMode:{
                id:0,
                failReason:"",
                status:0,
            }
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-100;
    },
    mounted(){
        this.query();
    },
    methods: {
        changeSumbit(isSumbit,scope){
            this.$confirm('确定更改提交状态吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    console.log(scope);
                    taskOtherChangeSumbit({isSumbit:isSumbit,orderId:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.IsSubmit=isSumbit;
                        }else{
                            this.$message.error(res.Message);
                        }
                    })
                }).catch(() => {
     
                });
        },
        canel(scope){
                this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.setRow=scope;
                    taskOtherCanel({orderId:this.setRow.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.query();
                    }else{
                        this.$message.error(res.Message);
                    }
                })
                }).catch(() => {
     
                });


        },
        close(){
            this.imageVisible=false
        },
        viewImg(list){
            this.viewImgList=list;
            this.imageVisible=true;
        },
        sumbitReview(status){
            this.reviewMode.status=status;
            taskOtherReview(this.reviewMode,(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.overVisible=false;
                        this.setRow.Status=this.reviewMode.status;
                        this.setRow.FailReason=this.reviewMode.failReason;
                    }else{
                        this.$message.error(res.Message);
                    }
            })
        },
        review(scope){
            this.reviewMode.id=scope.Id;
            this.setRow=scope;
            this.overVisible=true;
        },
        query(){
            this.isLoading=true;
            let arr=[]
            this.queryModel.times.forEach(x=>{
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
            taskOtherGetOrder({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryText:this.queryModel.queryTxt,
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                timeJson:this.queryModel.times==null?"[]":JSON.stringify(arr),
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
         reset(){
            this.queryModel={
                status:"",
                times:[],
                queryTxt:"",
                pIndex:1,
                pSize:20,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>